<template>
  <div v-if="feedbacks.data" class="feedback-list">
    <DashboardTitleSearch
      :property-name="this.$store.getters.property.name"
      :property-id="this.$store.getters.property.id"
      :category-id="this.$route.query.categoryId"
    />
    <div class="dashboard-top-section">
      <div class="search-display">
        <h2>
          "{{ keywords }}" search results
          <span v-if="this.$route.query.categoryId">
            - refined by category</span
          >
        </h2>
        <span v-if="!feedbacks.data.length">No Feedback!</span>
      </div>
      <div class="search-filter">
        <div class="sentiment-filter">
          <div>Sentiment Filter:</div>
          <img src="../assets/mad.png" @click="sentiment(1)" />
          <img src="../assets/neutral.png" @click="sentiment(5)" />
          <img src="../assets/happy.png" @click="sentiment(10)" />
        </div>
        <div
          v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
          class="pagination"
        >
          <button
            v-if="page > 1"
            class="button button-100 page-back"
            @click="pageBack"
          >
            Back
          </button>
          <div class="pagination-page">
            Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
          </div>
          <button
            v-if="page < Math.ceil(feedbacks.total_items / per_page)"
            class="button button-100 page-next"
            @click="pageNext"
          >
            Next
          </button>
        </div>
      </div>
      <div class="clearfix" />
      <div v-for="feedback in feedbacks.data" :key="feedback.id">
        <FeedbackItem :feedback="feedback" />
      </div>
    </div>
    <div
      v-if="Math.ceil(feedbacks.total_items / per_page) >= page"
      class="pagination"
    >
      <button
        v-if="page > 1"
        class="button button-100 page-back"
        @click="pageBack"
      >
        Back
      </button>
      <div class="pagination-page">
        Page {{ page }} of {{ Math.ceil(feedbacks.total_items / per_page) }}
      </div>
      <button
        v-if="page < Math.ceil(feedbacks.total_items / per_page)"
        class="button button-100 page-next"
        @click="pageNext"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import DashboardTitleSearch from "@/components/DashboardTitleSearch";
import FeedbackItem from "@/components/FeedbackItem";
import api from "@/api/index";
const apiService = new api.APIServiceFeedback();

export default {
  name: "DashboardFeedbackSearch",
  components: {
    DashboardTitleSearch,
    FeedbackItem
  },
  data() {
    return {
      feedbacks: [],
      page: 1,
      per_page: 25,
      total_items: 0,
      total_pages: 0,
      propertyID: this.$route.query.propertyID,
      keywords: this.$route.query.searchKeywords,
      sentimentScore: 0
    };
  },
  created() {
    this.getPropertyFeedbackSearch();
  },
  methods: {
    getPropertyFeedbackSearch: function() {
      apiService
        .searchFeedback(
          this.propertyID,
          this.$route.query.searchKeywords,
          this.page,
          this.$route.query.categoryId,
          this.sentimentScore
        )
        .then(data => {
          this.feedbacks = data;
        });
    },
    pageBack: function() {
      this.page = this.page - 1;
      this.getPropertyFeedbackSearch();
    },
    pageNext: function() {
      this.page = this.page + 1;
      this.getPropertyFeedbackSearch();
    },
    sentiment: function(score) {
      this.sentimentScore = score;
      this.getPropertyFeedbackSearch();
    }
  }
};
</script>

<style scoped>
#feedback {
  margin: 0 0;
}
.dashboard {
  lost-utility: clearfix;
}
.search-filter {
  width: 100%;
}
.sentiment-filter {
  width: 250px;
  float: left;
  vertical-align: middle;
}
.sentiment-filter div {
  padding-top: 5px;
  padding-right: 5px;
  float: left;
}
.sentiment-filter img {
  float: left;
  width: 30px;
}
.pagination {
  float: right;
  margin-bottom: 10px;
}
.pagination-page {
  padding-top: 12px;
  padding-right: 5px;
  float: left;
}
.sentiment-icons {
  text-align: center;
}
.sentiment-icons img {
  width: 30px;
  padding-top: 5px;
}
.feedback-list {
  lost-utility: clearfix;
}
.ngrams {
  padding: 0 3px 10px 10px;
  margin-bottom: 20px;
}
.ngrams-box {
  lost-column: 1/2;
}
.ngram span {
  font-size: 20px;
}

@media (max-width: 480px) {
  .full-box {
    lost-utility: clearfix;
  }
  h1 {
    font-size: 20px;
  }
}
</style>
